<template>
    <div class="page-abonements">
        <el-dialog
                title="Сменить тариф"
                :visible.sync="addVisible"
                width="435px"
        >
            <div>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-select :clearable="true" v-model="model.TariffID" placeholder="Выберите тариф" class="w-100">
                            <el-option
                                    v-for="item in $tarifDict"
                                    :key="item.ID"
                                    :label="item.Name"
                                    :multiple="false"
                                    :value="item.ID">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        &nbsp;
                    </el-col>
                    <el-col :span="12" class="m-t-20">
                        <el-button type="primary" class="w-100" icon="el-icon-check" @click="save" :loading="loading">Сменить</el-button>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>

        <el-card shadow="never" class="m-b-20">
            <el-row :gutter="20">
                <el-col :sm="24" :md="8" :lg="12" :xl="14" class="m-b-10 m-b-md-0">
                    <el-input placeholder="Искать карту"
                              v-model="form.Search"
                              v-on:change="getData"
                              clearable>
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                </el-col>
                <el-col :sm="24" :md="8" :lg="6" :xl="4">
                    <el-button class="w-100" type="primary" @click="handleFilter" icon="icon-search">Поиск</el-button>
                </el-col>
                <el-col :sm="24" :md="8" :lg="6" :xl="6" align="right" class="d-flex m-t-10 m-t-md-0">
                    <el-button class="w-50" @click="exportCSV" icon="icon-csv-file">{{ ($mobile() ? 'Экспорт ' : '') + 'CSV' }}</el-button>
                    <el-button class="w-50" @click="exportCSV" icon="icon-xls-file">{{ ($mobile() ? 'Экспорт ' : '') + 'Excel' }}</el-button>
                </el-col>
            </el-row>
        </el-card>
        <el-row :gutter="20">
            <el-col :span="24">
                <el-table v-loading="loading" :data="dataTable" :row-class-name="tableRowClassName">
                    <el-table-column prop="Company" label="Организация">
                        <template slot-scope="scope">
                            <div v-if="companyDict.find(x => x.ID === scope.row.CompanyID)" class="font-weight-bold">
                                <a href="#" @click.prevent="showDetails(scope.row.ID)" class="color-black">
                                    {{ companyDict.find(x => x.ID === scope.row.CompanyID).Name }}
                                </a>
                            </div>
                            <div v-else>-</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="CustomerID" label="Клиент">
                        <template slot-scope="scope">
                            <div v-if="customerDict.find(x => x.ID === scope.row.CustomerID)">
                                {{ customerDict.find(x => x.ID === scope.row.CustomerID).Name }}
                            </div>
                            <div v-else>-</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Card" label="Карта">
                        <template slot-scope="scope">
                            {{ Math.abs(parseInt(scope.row.ID)) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="LayoutVersion" label="Машиноместо" />
                    <el-table-column prop="Place" label="Автомобили" />
                    <el-table-column prop="TimeExpiration" label="Истекает">
                        <template slot-scope="scope">
                            <table-date :date="scope.row.TimeExpiration"/>
                        </template>
                    </el-table-column>
                    <el-table-column prop="CustomerGroupID" label="Группа">
                        <template slot-scope="scope">
                            <div v-if="$customerGroupDict.find(x => x.ID === scope.row.CustomerGroupID)">
                                {{ $customerGroupDict.find(x => x.ID === scope.row.CustomerGroupID).Name }}
                            </div>
                            <div v-else>-</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="TariffID" label="Тариф" v-if="$tarifDict">
                        <template slot-scope="scope">
                            <div v-if="$tarifDict.find(x => x.ID === scope.row.TariffID)">
                                {{$tarifDict.find(x => x.ID === scope.row.TariffID).Name}}
                            </div>
                            <div v-else>-</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="OnlinePaidTime" label="Дата оплаты">
                        <template slot-scope="scope">
                            <table-date :date="scope.row.OnlinePaidTime"/>
                        </template>
                    </el-table-column>
                    <el-table-column prop="OnlinePaid" label="Сумма">
                        <template slot-scope="scope">
                            {{ scope.row.OnlinePaid | rubles }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="Deactivated" label="Деактивирован">
                        <template slot-scope="scope">
                            <el-switch @change="activate" v-model="scope.row.Deactivated">
                            </el-switch>
                        </template>
                    </el-table-column>

                    <el-table-column
                            fixed="right"
                            label="Подробнее"
                            width="130px"
                            align="right"
                    >
                        <template slot-scope="scope">
                            <el-button @click="showTransactions(scope.row.CardID)" icon="el-icon-time" class="m-l-10 float-right el-button--icon" size="mini" title="Проезды"></el-button>
                            <el-button @click="changeTarif(scope.row)" icon="icon-edit-2" class="float-right el-button--icon" size="mini" title="Сменить тариф"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="m-t-20 text-center">
                    <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="form.Page"
                            :page-sizes="[10, 20, 100, 200, 300, 400]"
                            :page-size="form.PageSize"
                            layout="sizes, prev, pager, next, total"
                            :total="total">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import Vue from 'vue'

    export default {
        data () {
            return {
                loading: false,
                addVisible: false,
                form: {
                    From: Vue.moment().add(-30, 'days').format('DD/MM/YYYY HH:mm'),
                    To: Vue.moment().hour('23').minutes('59').format('DD/MM/YYYY HH:mm'),
                    Search: '',
                    Page: 1,
                    PageSize: 20
                },
                total: 0,
                dataTable: [],
                model: {},
                companyDict: [],
                customerDict: []
            }
        },
        created () {
            this.getCompanies()
            this.getCustomers()
            this.getData()
        },
        methods: {
            changeDate (date) {
                this.form.From = date[0]
                this.form.To = date[1]
                this.getData()
            },
            handleSizeChange (val) {
                this.form.PageSize = val
                this.getData()
            },
            handleCurrentChange (val) {
                this.form.Page = val
                this.getData()
            },
            handleFilter () {
                this.getData()
            },
            getData () {
                this.loading = true

                let request = Object.assign({
                    Name: "GetItemsList",
                    ItemType: "Card"
                }, this.form)

                this.$api.Main.getAbonements(request).then(response => {
                    this.loading = false
                    this.dataTable = response.Items
                    this.total = response.Total
                }).catch (() => {
                    this.loading = false
                })
            },
            getCompanies() {
                let request = Object.assign({
                    Name: "GetItemsList",
                    ItemType: "Company",
                    OperatorName: "Admin"
                }, this.form)

                this.$api.Main.getCompanies(request).then(response => {
                    this.companyDict = response.Items
                }).catch (() => {

                })
            },
            getCustomers () {
                let request = Object.assign({
                    Name: "GetItemsList",
                    ItemType: "Customer"
                }, this.form)

                this.$api.Main.getCustomers(request).then(response => {
                    this.customerDict = response.Items
                }).catch (() => {

                })
            },
            showDetails (id) {
                this.$router.push({ name: 'carDetails', params: { id: id } })
            },
            exportCSV () {
                console.log('export')
            },
            activate (id) {
                console.log('activate', id)
            },
            changeTarif (row) {
                this.model = {...row}
                this.addVisible = true
            },
            showTransactions (id) {
                this.$router.push({ name: 'cardDetails', params: { id: id } })
            },
            tableRowClassName({row}) {
                if (!row.Deactivated) {
                    return 'success-row';
                } else {
                    return 'warning-row';
                }
            },
            save () {
                console.log('save')
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
